export default "__VITE_ASSET__DqX4RV1v__"